module.exports = __webpack_public_path__ + "img/c-en-32.b0c0389e.png";